import { snack } from "components/Snack/Snack";
import CrudPage from "components/CrudPage/CrudPage";
import withRouter from "hoc/withRouter";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import roomTypesSAService from "services/superadmin/roomTypesSAService";
import AppSmartForm from "components/AppSmartForm/AppSmartForm";

const RoomTypeForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { roomType },
}) => {

  const fieldsWithData = [
    {
      key: "name",
      label: "Название",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "code",
      label: "Код типа комнаты",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "description",
      label: "Описание",
      required: true,
      inputType: inputTypeEnum.text,
    },
  ]

  const onSubmit = async (formValues) => {
    console.log("formValues: ", formValues);
    try {
      if (roomType) {
        await roomTypesSAService.put(id, formValues)
        snack("Тип комнаты обновлен успешно!");
      } else {
        await roomTypesSAService.post(formValues)
        snack("Тип комнаты создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={roomType ? 'Редактирование типа комнаты' : 'Создание типа комнаты'}>
      <AppSmartForm onSubmit={onSubmit} data={roomType} fields={fieldsWithData}></AppSmartForm>
    </CrudPage>
  );
};

export default withRouter(
  withRemoteDataAndSpinner(RoomTypeForm, (router) => {
    let requests = {}

    if (router.params.id) {
      requests['roomType'] = () => roomTypesSAService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
